import { Component, Input, OnChanges, OnInit } from '@angular/core';

/**
 * Componente de banner corporativo.
 * Muestra un mensaje y el logo de la empresa si la reserva tiene reconocimiento corporativo.
 */

@Component({
    selector: 'am-banner-corporate',
    templateUrl: './am-banner-corporate.component.html',
    styleUrls: ['./am-banner-corporate.component.scss'],
    standalone: false
})
export class AmBannerCorporateComponent implements OnInit, OnChanges {

/**
   * Información de la reserva previa, que puede incluir reconocimiento corporativo.
   */
@Input() reservationOld: any;
@Input() isNeedVeryPass: boolean = false;

/**
 * Indica si el banner debe mostrarse.
 */
showBanner = true;

/**
 * Mensaje que se mostrará en el banner.
 */
messageBanner: string = '';

/**
 * Información del reconocimiento corporativo extraída de la reserva.
 */
corporateRecognition: any;

/**
 * Nombre de la empresa asociado a la reserva corporativa.
 */
companyName: string = '';

/**
 * URL del logo de la empresa.
 */
companyLogo: string = '';

  constructor(
  ) { }

  ngOnInit() {
  }

  /**
   * Detecta cambios en la reserva y actualiza la información del banner.
   */
  ngOnChanges() {
    this.corporateRecognition = this.reservationOld?.corporateRecognition || {};
    if (this.corporateRecognition && !this.showBanner) {
      this.messageBanner = 'bannerCorp.msgCorp';
      this.companyName = this.corporateRecognition?.companyName;
      this.companyLogo = this.corporateRecognition?.companyLogo;
    } else {
      this.messageBanner = 'bannerCorp.msgGeneral';
    }
  }
/**
   * Maneja errores en la carga de imágenes ocultando el elemento de la imagen.
   * @param event Evento de error de la imagen.
   * @param element Elemento de imagen en el DOM.
   */
  onErrorImage(event, element: HTMLImageElement) {
    element.style.display = 'none'
  }

}
